import { createFileRoute } from '@tanstack/react-router'
import Memberships from '@/features/memberships'

export const Route = createFileRoute('/_authenticated/memberships/')({
  component: Memberships,
})

